import { render, staticRenderFns } from "./CreateNomenclaturePacket.vue?vue&type=template&id=7ff27d50&scoped=true"
import script from "./CreateNomenclaturePacket.vue?vue&type=script&lang=js"
export * from "./CreateNomenclaturePacket.vue?vue&type=script&lang=js"
import style0 from "./CreateNomenclaturePacket.vue?vue&type=style&index=0&id=7ff27d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff27d50",
  null
  
)

export default component.exports